import { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getFeatureToggles } from 'store/featureToggles/featureTogglesApi';
import { FEATURE_TOGGLES } from 'constants/featureToggles';

const useFeatureTogglesInterval = (isAppReady) => {
    const dispatch = useDispatch();
    const intervalId = useRef(null);

    useEffect(() => {
        if (isAppReady) {
            // Dispatch the action immediately on mount
            dispatch(getFeatureToggles());

            // Set up the interval to dispatch the action every 10 minutes
            intervalId.current = setInterval(
                () => {
                    dispatch(getFeatureToggles());
                },
                10 * 60 * 1000
            ); // 10 minutes in milliseconds

            // Cleanup interval on component unmount
            return () => {
                if (intervalId.current) {
                    clearInterval(intervalId.current);
                }
            };
        }
    }, [dispatch, isAppReady]);
};

const useIsFeatureToggleActive = (name) => {
    const { toggles } = useSelector((state) => state.featureToggles);

    // Get the feature toggle key from the FEATURE_TOGGLES object
    const featureToggleKey = Object.values(FEATURE_TOGGLES).find(
        (toggle) => toggle.trim().toUpperCase() === name.trim().toUpperCase()
    );

    if (!featureToggleKey) {
        //return false if name does not match a listed feature toggle
        return false;
    }

    //return the isEnabled value of the feature toggle, if it is found
    const currentToggle = toggles.featureToggles.find((toggle) => toggle.name === featureToggleKey);
    if (currentToggle) {
        return currentToggle.isEnabled;
    }

    //return false if the feature toggle is not found
    return false;
};

export { useFeatureTogglesInterval, useIsFeatureToggleActive };
